import { useQuery } from "react-query";
import { PageConfigurationDataModel3, PageConfigurationTypeEnum } from "../../../services/page-configuration-service/Models";
import PageConfigurationService from "../../../services/page-configuration-service/PageConfigurationService";
import { RestError } from "../../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseDeviceSummaryConfigurationsParameters = {
    groupID: number
} & BaseUseQueryParameters<PageConfigurationDataModel3>;

export function useDeviceSummaryConfigurations({
    groupID,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseDeviceSummaryConfigurationsParameters) {
    return useQuery<PageConfigurationDataModel3, RestError>(
        keys.configurationList(groupID),
        ({ signal }) => {
            return PageConfigurationService.getAccessiblePageConfigurations3(groupID, PageConfigurationTypeEnum.SummaryListing_RTS, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }        
    );
}
